/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromotionCode } from '../../models/promotion-code';
import { PromotionCodeApiRespModel } from '../../models/promotion-code-api-resp-model';

export interface ApiMasterPromotionCodeAddPost$Params {
      body?: PromotionCode
}

export function apiMasterPromotionCodeAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterPromotionCodeAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<PromotionCodeApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterPromotionCodeAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PromotionCodeApiRespModel>;
    })
  );
}

apiMasterPromotionCodeAddPost.PATH = '/api/Master/PromotionCode/Add';
